module.exports = __webpack_public_path__ + "assets/img/more.7b543768.png";